import Button from 'features/common/components/Button'
import logo from 'assets/logo.svg'
import {MobileAuthStage} from '../core/entities'
import LanguageSelect from './common/components/LanguageSelect'
import {landingLink} from 'features/unauthorized/components/AuthPage/common/core/constants'
import {useTranslation} from 'react-i18next'

const MenuStage = (props: {
    onClickStageButtons: (as: MobileAuthStage) => () => void
}) => {
    const {t} = useTranslation()
    const redirectToLanding = () => {
        window.location.href = landingLink
    }
    const {onClickStageButtons} = props
    return (
        <div className="flex flex-1 flex-col items-center pb-10">
            <div className="mb-14 flex items-center justify-center gap-5 xs:mb-24">
                <div className="absolute top-0 left-1/2 h-[20rem] w-[20rem] -translate-y-3/4 -translate-x-1/2 rounded-full bg-yellow-40 xs:h-[22.5rem] xs:w-[22.5rem] xs:-translate-y-2/3" />
                <img
                    className="z-10 w-36 py-3 xs:w-40 xs:py-6"
                    src={logo}
                    onClick={redirectToLanding}
                    alt="no coins"
                />
            </div>
            <div className="xs:mb-18 mb-10 flex flex-col items-center text-center font-bold text-yellow-40">
                <div className="text-2xl xs:text-[1.75rem]">
                    {t('AUTH_CASHLESS_TIPS')}
                </div>
                <div className="text-xl xs:text-2xl">{t('AUTH_UP_TO_40')}</div>
            </div>
            <div className="mb-7 flex min-w-[12rem] flex-col items-stretch gap-5 font-bold text-yellow-40 xs:mb-9">
                <Button
                    className="flex-1 rounded-full bg-yellow-40 py-3 px-3"
                    onClick={onClickStageButtons('signin')}
                >
                    {t('AUTH_SIGNIN_BUTTON')}
                </Button>
                <Button
                    className="flex-1 rounded-full bg-yellow-40 py-3 px-5"
                    onClick={onClickStageButtons('signup')}
                >
                    {t('AUTH_SIGNUP_BUTTON')}
                </Button>
            </div>
            <LanguageSelect />
        </div>
    )
}

export default MenuStage
